import React from 'react';

import PropTypes from 'prop-types';

import styles from './EmptyPromoCards.scss';

import bootstrap from '@src/css/bootstrap.scss';


export const EmptyArticlesPromoCard = ({
    customClass,
}) => {
    return (
        <div className={`${bootstrap.card} promocard_quarter_size ${styles.GeneralPromoCard_empty_card} ${customClass}`} />
    );
};

EmptyArticlesPromoCard.propTypes = {
    customClass: PropTypes.string,
};

export default EmptyArticlesPromoCard;
